/* ================== ELEMENTS ================== */

const mainContainer = document.getElementById("main-tangent-quiz-container");
const quizBlock = document.querySelector(".tangent-quiz-block");
const iconBlock = document.querySelector(".icon-container");
const imageBlock = document.querySelector(".welcome-screen-video-container");

/* ================== STATE ================== */

let qIndex = 0;
let currentAngle = 0;

let fragranceCategory = "";
let selected = {
    step3: "",
    step4: "",
    step5: ""
};

let finalIcon = "";
let finalBgImage_subtle = "";
let finalBgImage_prominent = "";
let finalBgOptionSelected = false;

/* ================== FRAGRANCE DATA ================== */

const fragranceConfig = {
    floral: {
        step1: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step1_flower.png",
        step2: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step2_flower.png",
        step3: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step3_flower.png",
        step4: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/heaven.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/inflorescence.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/git.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/silk_bouquet.png"
        ],
        bg_subtle: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_heaven1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_inflorescence1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_git1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_silkbouquet1.jpg"
        ],
        bg_prominent: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_heaven2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_inflorescence2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_git2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_silkbouquet2.jpg"
        ]
    },

    woody: {
        step1: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step1_woody.png",
        step2: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step2_woody.png",
        step3: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step3_woody.png",
        step4: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/earth.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/gentle_shower.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/hanok.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/royal_resin.png"
        ],
        bg_subtle: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_earth1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_gentleshower1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_hanok1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_royalresin1.jpg"
        ],
        bg_prominent: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_earth2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_gentleshower2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_hanok2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_royalesin2.jpg"
        ]
    },

    fresh: {
        step1: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step1_fresh.png",
        step2: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step2_fresh.png",
        step3: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step3_fresh.png",
        step4: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/water.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/hazy_blue.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/haenyeo.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/bae_frais.png"
        ],
        bg_subtle: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_water1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_hazyblue1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_haenyeo1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_baefrais1.jpg"
        ],
        bg_prominent: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_water2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_hazyblue2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_haenyeo2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_baefraise2.jpg"
        ]
    },

    warm: {
        step1: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step1_warm.png",
        step2: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step2_warm.png",
        step3: "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/step3_warm.png",
        step4: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/fire.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/be_by_my_side.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/jang.png",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/cloud_daze.png"
        ],
        bg_subtle: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_fire1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_bebymyside1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_jang1.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_clouddaze1.jpg"
        ],
        bg_prominent: [
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_fire2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_bebymyside2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_jang2.jpg",
            "https://cdn.shopify.com/s/files/1/0406/4074/1544/files/BG_clouddaze2.jpg"
        ]
    }
};

/* ========PRELOAD IMAGES FROM THE FRAGRANCE CONFIG======== */
function preloadFragranceImages() {
    const urls = new Set(); // avoid duplicates

    Object.values(fragranceConfig).forEach((group) => {
        // step1, step2, step3
        urls.add(group.step1);
        urls.add(group.step2);
        urls.add(group.step3);

        // step4 array
        group.step4.forEach((url) => urls.add(url));

        // bg array
        group.bg_subtle.forEach((url) => urls.add(url));
        group.bg_prominent.forEach((url) => urls.add(url));
    });

    urls.forEach((url) => {
        const img = new Image();
        img.src = url;
    });

    console.log(`Preloaded ${urls.size} images`);
}

/* ================== HELPERS ================== */

function getCurrentStep(q) {
    if (q < 4) return 1;
    if (q === 4) return 2;
    if (q === 5) return 3;
    if (q > 5 && q < 10) return 4;
    if (q === 10) return 5;
    if (q === 11) return 6;

    return 0;
}

function modifyQIndex(q) {
    if (q === 3 || q === 11) return 3;
    if (q === 4 || q === 12) return 4;
    if (q === 5 || q === 13) return 5;
    if (q === 6 || q === 14) return 6;
    if (q === 7 || q === 15) return 7;
    if (q === 8 || q === 16) return 8;
    if (q === 9 || q === 17) return 9;
    if (q === 10 || q === 18) return 10;
    if (q === 19) return 11;
    return q;
}

function getIcon() {
    const icon = document.getElementById(fragranceCategory);
    if (!icon) return;
    return icon.querySelector("img");
}

/* ================== QUIZ EVENTS ================== */

document.addEventListener("DOMContentLoaded", () => {
    preloadFragranceImages();
});


window.addEventListener("quiz_progress", (e) => {
    const parts = e.detail.split("_");

    qIndex = modifyQIndex(Number(parts[0]));
    // const modifiedQIndex = modifyQIndex(qIndex);
    const total = 11;
    const questionID = parts[3];
    updateProgressBar(qIndex, total)
    const step = getCurrentStep(qIndex);

    if (step === 5) {
        mainContainer.style.setProperty(
            "--quiz-bg-image",
            `url(${finalBgOptionSelected ? finalBgImage_prominent : finalBgImage_subtle})`
        );
        mainContainer.style.background = "none";
        // mainContainer.style.setProperty("--bg-opacity", 0.5);
    }
    if (step === 6) {
        mainContainer.style.setProperty(
            "--quiz-bg-image",
            `url("")`
        );
        mainContainer.style.background = "#000";
    }

    handleDisplayIcon(step);

    handleHeader(qIndex);
});

/* ================== UI ================== */

function updateProgressBar(present, total) {
    let progressBar = document.getElementById("progress-bar");
    let progressBarBlock = document.getElementById("progress-bar-block");
    if (present != "0") {
        progressBarBlock.style.display = "block";
        progressBar.style.width = (present / total) * 100 + "%";
    }
    if (present == "0" || present > total) {
        progressBarBlock.style.display = "none";
    }
}

function handleHeader(qIndex) {
    if (qIndex === 0) {
        iconBlock.style.display = "none";
        imageBlock.style.display = "flex";
    } else {
        iconBlock.style.display = "flex";
        imageBlock.style.display = "none";
    }
}

/* ================== CLICK HANDLER ================== */

document.addEventListener("click", handleOptionClick, true);

function handleOptionClick(e) {
    const option = e.target.closest(".tangent_options_custom");
    if (!option) return;

    const parent = option.parentElement;

    const siblings = parent.querySelectorAll(
        ":scope > .tangent_options_custom"
    );

    // Apply brightness styles
    siblings.forEach((el) => {
        if (el === option) {
            el.style.opacity = "1";
        } else {
            el.style.opacity = "0.5";
        }
    });

    const index = [...siblings].indexOf(option);

    const text = option.textContent.trim().toLowerCase();

    const step = getCurrentStep(qIndex);

    /* -------- STEP 2 -------- */

    if (step === 2) {
        handleStep2(text);
        return;
    }

    /* -------- STEP 3 -------- */

    if (step === 3) {
        handleStep3(text, index);
        return;
    }

    /* -------- STEP 4 -------- */

    if (step === 4) {
        handleStep4(text, index);
        return;
    }

    /* -------- STEP 5 -------- */

    if (step === 5) {
        handleStep5(text);
    }
}

/* ================== STEP HANDLERS ================== */

function handleStep2(text) {
    const previcon = document.getElementById(fragranceCategory);
    if (previcon) {
        const previconImg = previcon.querySelector("img");
        previconImg.src = fragranceConfig[fragranceCategory].step1;
    }
    const icon = document.getElementById(text);
    const iconImg = icon.querySelector("img");
    if (!iconImg) return;

    changeIcon(iconImg, icon, fragranceConfig[text].step2)
    fragranceCategory = text;

    reduceBrightness();
}

function reduceBrightness() {
    const icons = iconBlock.children;
    Array.from(icons).forEach(icon => {
        if (icon.id === fragranceCategory) {
            icon.style.opacity = "1";
        } else {
            icon.style.opacity = "0.5";
        }
    });
}

function handleStep3(text, index) {
    if (!fragranceCategory) return;

    const icon = getIcon();

    !selected.step3 ? swapAndRotate(icon, fragranceConfig[fragranceCategory].step3) : icon.src = fragranceConfig[fragranceCategory].step3;
    selected.step3 = text;

    // if (selected.step3 === text) {
    //     icon.src = fragranceConfig[fragranceCategory].step2;
    //     selected.step3 = "";
    // }
}

function handleStep4(text, index) {
    if (!fragranceCategory) return;

    const icon = getIcon();
    let finalIcon = fragranceConfig[fragranceCategory].step4[index];

    console.log(finalIcon);

    handleShimmerAnimation(icon, finalIcon);
    selected.step4 = text;

    finalBgImage_subtle = fragranceConfig[fragranceCategory].bg_subtle[index];
    finalBgImage_prominent = fragranceConfig[fragranceCategory].bg_prominent[index];
    finalIcon = finalIcon;

    // if (selected.step4 === text) {
    //     icon.src = fragranceConfig[fragranceCategory].step3;
    //     selected.step4 = "";
    // }
}

function handleStep5(text) {
    if (!selected.step5) {
        mainContainer.style.setProperty(
            "--quiz-bg-image",
            `url(${finalBgImage_prominent})`
        );
        // mainContainer.style.setProperty("--bg-opacity", 1);
        mainContainer.classList.add("bg-zoom");
    }

    selected.step5 = text;
    finalBgOptionSelected = true;

    // if (selected.step5 === text) {
    //     quizBlock.style.setProperty("--bg-opacity", 0.5);
    //     quizBlock.classList.remove("bg-zoom");

    //     selected.step5 = "";
    // }
}

function handleDisplayIcon(step) {
    const icons = iconBlock.children;
    Array.from(icons).forEach(icon => {
        if ((step == 5 || step == 6 || step == 0) && icon.id != fragranceCategory) {
            icon.style.display = "none";
        } else {
            icon.style.display = "block";
        }
    });
}


/* ================== ANIMATION HANDLERS =============== */

function changeIcon(img, icon, newSrc) {
    // Change src
    img.src = newSrc;
    icon.classList.add("fade-in");
    // Animate IN
    setTimeout(() => {
        icon.classList.remove("fade-in");
    }, 750)
}

function swapAndRotate(img, newSrc) {
    img.src = newSrc;
    img.offsetHeight;
    img.classList.add("rotate");
    setTimeout(() => {
        img.classList.remove("rotate");
    }, 1500)
}

function handleShimmerAnimation(img, finalIcon) {
    const iconBlock = document.getElementById(fragranceCategory);
    img.classList.add("fade-in");
    img.src = finalIcon;
    setTimeout(() => {
        img.classList.remove("fade-in");
        iconBlock.classList.add("shimmer");
    }, 500)

    setTimeout(() => {
        iconBlock.classList.remove("shimmer");
    }, 1500)
}




/* ================== BACK BUTTON ================== */

document.addEventListener("click", handleBackButton, true);

function handleBackButton(e) {
    const btn = e.target.closest(".tangent_backbtn_custom");
    if (!btn) return;

    setTimeout(() => {
        handleBackBtnBrightness();
    }, 50)

    const icon = getIcon();
    const step = getCurrentStep(qIndex);

    if (!icon) return;

    if (step === 4) {
        icon.src = fragranceConfig[fragranceCategory].step3;
        selected.step4 = "";
    }

    if (step === 3) {
        icon.src = fragranceConfig[fragranceCategory].step2;
        selected.step3 = "";
    }

    if (step === 2) {
        icon.src = fragranceConfig[fragranceCategory].step1;
        fragranceCategory = "";

        resetBrightness();
    }

    if (step === 5) {
        mainContainer.classList.remove("bg-zoom");
        mainContainer.style.setProperty("--quiz-bg-image", "");
        mainContainer.style.background = "#000";
        finalBgOptionSelected = false;
        selected.step5 = "";
    }
    if (step === 6) {
        mainContainer.style.setProperty(
            "--quiz-bg-image",
            `url(${finalBgImage_prominent})`
        );
        mainContainer.style.background = "none";
    }
}

function resetBrightness() {
    const icons = iconBlock.children;
    Array.from(icons).forEach(icon => {
        icon.style.opacity = "1";
    });
}

function handleBackBtnBrightness() {
    const optionBlock = document.querySelector(".tangent_options_container_custom");
    if (!optionBlock) return;

    const options = Array.from(optionBlock.children);

    options.forEach(option => {
        option.style.opacity = option.classList.contains("tangent_option_highlight_custom") ? "1" : "0.5";
    });
}
